export const DEFAULT_PAGE_SIZE = 10;
export const MAX_VISIBLE_COLUMNS = 8;
export const DEFAULT_PER_PAGE_OPTIONS: number[] = [10, 50, 100, 500];
